import { cn } from "@/shared/lib/cn";

type Props = {
  name: string;
  size?: number;
  grad?: [string, string];
  className?: string;
};

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/);
  return parts.slice(0, 2).map((p) => p[0]?.toUpperCase() ?? "").join("");
}

export function Avatar({ name, size = 36, grad = ["#BFF93F", "#1C1C1C"], className }: Props) {
  return (
    <div
      className={cn("inline-flex items-center justify-center rounded-full text-white font-display font-bold select-none", className)}
      style={{
        width: size,
        height: size,
        background: `linear-gradient(135deg, ${grad[0]}, ${grad[1]})`,
        fontSize: Math.round(size * 0.4),
      }}
    >
      {initialsOf(name)}
    </div>
  );
}
